export default __webpack_public_path__ + "static/light-mode-030166f4c7abbe5733c34ecd290f5452.png";